import React, { Component } from "react";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import Home from "./screens/Home";

const theme = createMuiTheme({
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["AccordAlt", "Montserrat", "sans-serif"].join(","),
    useNextVariants: true
  },
  palette: {
    primary: {
      main: "#00ca6e"
    }
  }
});

class App extends Component {
  render() {
    return (
      <div id="app">
        <MuiThemeProvider theme={theme}>
          <Home />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default App;
